module.exports = __webpack_public_path__ + "static/media/stop-white.79301a3b.svg";